import { render } from "./HelloI18n.vue?vue&type=template&id=3b61450a"
import script from "./HelloI18n.vue?vue&type=script&lang=js"
export * from "./HelloI18n.vue?vue&type=script&lang=js"
script.render = render

export default script